import { GeosetsImportPage, GeofencesRoute } from './-components';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { GEOSET_IMPORT_PERMISSION } from '@/pages/workspaces/geosets/import/constants';

/** Search params the import page understands. */
type GeosetImportSearch = {
  /** Preselects the target geoset in the setup combobox (geoset entity id). */
  geoset?: string;
};

function GeosetsImportRoute() {
  const router = useRouter();

  return (
    <GeofencesRoute
      permission={GEOSET_IMPORT_PERMISSION}
      redirectTo={(params) =>
        router.buildLocation({
          to: '/workspaces/$workspaceId/geosets',
          params: { workspaceId: params.workspaceId },
        }).href
      }
    >
      <GeosetsImportPage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geosets/import')({
  component: GeosetsImportRoute,
  validateSearch: (search: Record<string, unknown>): GeosetImportSearch => ({
    geoset: typeof search.geoset === 'string' ? search.geoset : undefined,
  }),
});
